export enum EndorsementType {
  None,
  Bates,
  Text,
  Tag
}
